import { render, staticRenderFns } from "./SurveyQuestionEditor.vue?vue&type=template&id=4aaa508c&scoped=true&"
import script from "./SurveyQuestionEditor.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionEditor.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQuestionEditor.vue?vue&type=style&index=0&id=4aaa508c&lang=scss&scoped=true&"
import style1 from "./SurveyQuestionEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa508c",
  null
  
)

export default component.exports